import styled from "styled-components";

const OrderDetailsWrapper = styled.div`
    .expand-collapse-class{
        display: flex;
        h4{
            background: #005586;
            padding: 0px;
            width: 17px;
            border-radius: 50%;
            height: 16px;
            margin: 3px 0px 0px 11px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 13px 6px;
                transform: rotate(-135deg);
                -webkit-transform: rotate(-135deg);
            }
        }  
        h5{
            background: #005586;
            padding: 0px;
            width: 16px;
            border-radius: 50%;
            height: 16px;
            margin: 3px 0px 0px 11px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 13px 5px;
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
            }
        }
    }
    .order-details-wrapper{
        td{
            border: none;
        }
        h6{
            font-size: 13px;
            font-weight: bold;
        }
        p{
            font-size: 14px;
        }
        .print-tag-style{
            border: 1px solid #E5E5E5;
            padding: 3px 2px 4px 11px;
            border-radius: 3px;
            background: #fff;
        }
    }
`;

const InvoiceActionWrapper = styled.div`
    .action-header{
        display: flex;
        width: 100%;
        padding: 20px;
        flex-wrap: wrap;
        gap:20px;
        align-items: start;
    }
    .location-wrapper-invoice{
        width: 220px;
    }
    .react-select__control, .custom-select-input, .select__control {
        border: solid 1px #87cdf1;
        border-radius: 6px;
    }
    .react-select__value-container {
        padding-left: 10px;
        padding-right: 10px;
    }
    .react-select__single-value {
        font-size: 14px;

    }
    .react-select__option {
        font-size: 14px;
        padding-left: 18px;

    }
    .custom-select__control{
        min-height: 40px !important;
    }
    .file-input-wrapper .MuiFormControl-root, .css-yk16xz-control{
        min-height: 42px !important;
    }
`

const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  > div {
    display: flex;
    p {
      margin: 12px;
    }
  }
  select,
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
  .date-picker-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
    max-width: 362;
  }
  @media (max-width: 650px) {
    > div {
      flex-direction: column;
    }
  }
  @media (max-width: 465px){
    .date-picker-wrapper{
      align-items: flex-start;
      > div{
        width: 100%;
        margin: 5px 0;
      }
    }
  }
`;
const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  border-radius: 4.2px;
  overflow: auto;
  max-width: 200px;
  min-width: 165px;
  width: 100%;
  justify-content: end;
  border: solid 1px #87cdf1;
  border-radius: 6px;
  input {
    background: #ffffff;
    border: none;
    padding: 4px 35px 4px 15px;
    width: 100%;
    border-radius: 3px;
    height: 30px;
    margin: 5px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #00000087;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #00000087;
    }

    ::placeholder {
      color: #00000087;
    }
  }
  svg {
    position: absolute;
    right: 10px;
    top: 16px;
    color: #525e66;
  }
  @media (max-width: 465px){
    margin-left: 0px;
    max-width: 100%;
  }
`;
export {
    OrderDetailsWrapper,
    InvoiceActionWrapper,
    SelectWrapper,
    SearchWrapper
};